import { render } from "./cardSell.vue?vue&type=template&id=2f5c2aa6&scoped=true&ts=true"
import script from "./cardSell.vue?vue&type=script&lang=ts"
export * from "./cardSell.vue?vue&type=script&lang=ts"

import "./cardSell.vue?vue&type=style&index=0&id=2f5c2aa6&lang=scss&scoped=true"

import exportComponent from "D:\\cabWork\\julang-admin-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f5c2aa6"]])

export default __exports__